import { render, staticRenderFns } from "./EditOrganizationSsoConfig.vue?vue&type=template&id=624c9ba3"
import script from "./EditOrganizationSsoConfig.vue?vue&type=script&lang=js"
export * from "./EditOrganizationSsoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports